import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {ConfirmationService, SelectItem, SortEvent} from 'primeng/api';
import {DialogService} from 'primeng/dynamicdialog';
import {AuthenticationService} from '../../authenticationModule/services/authentication.service';
import {UserService} from '../../generated/api/user.service';
import {UtilsService} from '../../appSharedModule/services/utils.service';
import {CustomUserService} from '../../services/custom-user.service';
import {UserLoggedRolesServiceService} from '../../authenticationModule/services/user-logged-roles-service.service';
import {CompanyService} from '../../generated/api/company.service';
import {TableService} from '../../services/table.service';
import {RoleService} from '../../services/role.service';
import {DatePipe} from '@angular/common';
import * as _ from 'lodash';
import {UserSearchCriteria} from '../../models/filter/user-search-criteria';
import {firstValueFrom} from 'rxjs';
import {OverlayPanel} from 'primeng/overlaypanel';
import {saveAs} from 'file-saver';
import {ManageInvoiceRecipientsService} from '../../services/manage-invoice-recipients.service';
import {MessageDialogComponent} from '../message-dialog/message-dialog.component';
import {BaseClientComponent} from '../base-client.component';
import {User} from '../../models/user';
import {Company} from '../../models/company';
import {UserLogged} from '../../models/userLogged';
import {HttpErrorResponse} from '@angular/common/http';

@Component({
  selector: 'app-list-users',
  templateUrl: './list-user.component.html',
  styleUrls: ['./list-user.component.css']
})
export class ListUsersComponent extends BaseClientComponent implements OnInit {

  oneUserWithDifferentDomainName = false;
  error = false;
  authorizationError = false;
  userNotFound = false;
  deleteLastSuperUserError = false;
  notAuthorized = false;
  successInvalidateUser = false;
  errorInvalidateUser = false;
  validateUserErrorMessage: string;
  companyUniqid : string;
  cols: any[];
  users: User[];
  filteredListUsers: User[];
  currentUser: UserLogged;
  currentCompany: Company;
  loading = true;
  deletedUserIds: number[] = [];
  roleCheckBoxes: SelectItem[];
  billingAccountCheckBoxes: SelectItem[];
  quickExportCols: any[];
  usersToExport: User[];
  maxVisibleBillingAccounts = 2;
  private expandedBillingAccounts: string[] = [];

  userSearchCriteria: UserSearchCriteria;
  userChoicesFiltersDefaultUsers = {
    nameOrEmail: '',
    billingAccount: [],
    roles: []
  };

  userChoicesActiveFilters = _.clone(this.userChoicesFiltersDefaultUsers);
  filterName: string;
  success = false;
  successMessage = '';
  authorizationErrorMessage = '';

  constructor(private route: ActivatedRoute,
              private authenticationService: AuthenticationService,
              private swaggerGeneratedUserService: UserService,
              private roleService: RoleService,
              private utilsService: UtilsService,
              private datePipe: DatePipe,
              private customUserService: CustomUserService,
              private userLoggedRolesServiceService: UserLoggedRolesServiceService,
              private companyService: CompanyService,
              private tableService: TableService,
              private confirmationService: ConfirmationService,
              private manageInvoiceRecipientsService: ManageInvoiceRecipientsService,
              private dialogService: DialogService) {
    super();
    this.roleCheckBoxes = this.roleService.roles.map(role => {
      return {
        label: role.sfGuardGroupDescription,
        value: role.sfGuardGroupName,
      };
    });

    this.cols = [
      {
        field: 'isActive',
        header: 'Valid',
        sortDisabled: true,
        class: '',
        tooltip: 'A valid user can receive announcements. You may invalidate a user temporarily.'
      },
      {field: 'email', header: 'Email', sortDisabled: false, class: 'email-width'},
      {field: 'name', header: 'Name', sortDisabled: false, class: ''},
      {
        field: 'commercialOptIn',
        header: 'Opt-in',
        sortDisabled: true,
        class: 'opt-in-width',
        tooltip: 'An opted-in user can receive marketing emails.'
      },
      {field: 'mobilePhone', header: 'Mobile', sortDisabled: false, class: ''},
      {field: 'roleGroupsNames', header: 'Roles', sortDisabled: true, class: 'role-width'},
      {field: 'billingAccountsNames', header: 'Business Units', sortDisabled: true, class: ''},
      {field: 'lastLoginStringFormat', header: 'Last login', sortDisabled: true, class: ''},
      {field: 'lastApiCalledStringFormat', header: 'Last Api', sortDisabled: true, class: ''},
      {field: 'action', header: 'Actions', sortDisabled: true, class: '', exportable: false},
      {field: 'goAction', header: 'Go', sortDisabled: true, class: '', exportable: false}
    ];

    this.quickExportCols = [
      {field: 'email', header: 'Email'},
      {field: 'name', header: 'Name'},
      {field: 'roleGroupsNames', header: 'Role'},
      {field: 'lastLogin', header: 'Last login'}
    ];
  }

  ngOnInit(): void {
    this.utilsService.lockUi();
    this.currentUser = this.authenticationService.userCurrent;
    this.route.paramMap.subscribe(params => {
      const currentCompanyUniqId = params.get('currentCompanyUniqId');
      this.companyUniqid = params.get('companyUniqId');
      if (this.companyUniqid === currentCompanyUniqId) {
        this.filterName = 'userFilter';
      } else {
        this.filterName = this.companyUniqid + 'userFilter';
      }
      this.userChoicesActiveFilters = this.utilsService.loadUserPref(this.filterName, this.userChoicesFiltersDefaultUsers);
      this.userSearchCriteria = new UserSearchCriteria(this.userChoicesActiveFilters);
      if (currentCompanyUniqId !== this.getUserCurrent().company.uniqid) {
        this.notAuthorized = true;
        return;
      }
      if (currentCompanyUniqId !== 'admin' && this.companyUniqid !== this.getUserCurrent().company.uniqid) {
        this.notAuthorized = true;
        return;
      }
      if (this.companyUniqid !== currentCompanyUniqId) {
        this.companyService.getCompanyItem(this.companyUniqid).subscribe({
            next: company => {
              this.currentCompany = company[0];
              this.billingAccountCheckBoxes = [];
              for (const billingAccount of this.currentCompany.billingAccounts) {
                this.billingAccountCheckBoxes.push({label: billingAccount.name, value: billingAccount.name});
              }
            }, error: () => {
              this.notAuthorized = true;
              return;
            }
          }
        );
      } else {
        this.currentCompany = this.currentUser.company;
        this.billingAccountCheckBoxes = [];
        for (const billingAccount of this.currentCompany.billingAccounts) {
          this.billingAccountCheckBoxes.push({label: billingAccount.name, value: billingAccount.name});
        }
      }
      const response$ = this.authenticationService.waitForAuthenticationThenLaunch(() => {
        this.fetchUserList();
      });
      this.subscriptions.push(response$);
    });
  }
  private  fetchUserList() {
    this.swaggerGeneratedUserService.getUserCollection(this.companyUniqid).subscribe(
      users => {
        this.users = users;
        this.oneUserWithDifferentDomainName = !!users.find(user => user.hasDifferentDomain);
        this.filteredUsers();
        this.loading = false;
        this.utilsService.unlockUi();
        for (const user of users) {
          user.roleGroupsNames = this.roleService.parseToString(user.roleGroups);
          user.billingAccountsNames = user.billingAccounts.map(ba => ba.name).join(', ');
          user.lastLoginStringFormat = this.parseToStringDate(user.lastLogin);
          user.lastApiCalledStringFormat = this.parseToStringDate(user.lastApiCalled);
        }
      },
      () => {
        this.redirectionToNotFound();
      }
    );
  }

  redirectionToNotFound() {
    this.utilsService.redirectToNotFound();
  }

  getMobilePhone(user: User): string {
    if (!user || !user.mobilePhone) {
      return '';
    }
    return user.mobilePhone;
  }

  parseToStringRoles(user: User): string {
    return this.roleService.parseToString(user.roleGroups);
  }

  getVisibleBillingAccounts(user: User): string[] {
    const accounts = user.billingAccounts.map(ba => ba.name);
    if (this.isBillingAccountsExpanded(user) || accounts.length <= this.maxVisibleBillingAccounts) {
      return accounts;
    }
    return accounts.slice(0, this.maxVisibleBillingAccounts);
  }

  hasMoreBillingAccounts(user: User): boolean {
    return user.billingAccounts.length > this.maxVisibleBillingAccounts;
  }

  isBillingAccountsExpanded(user: User): boolean {
    return this.expandedBillingAccounts.includes(user.uniqid);
  }

  toggleBillingAccountsExpansion(user: User, event: Event): void {
    event.stopPropagation();
    if (this.expandedBillingAccounts.includes(user.uniqid)) {
      this.expandedBillingAccounts = this.expandedBillingAccounts.filter(uniqid => uniqid !== user.uniqid);
    } else {
      this.expandedBillingAccounts.push(user.uniqid);
    }
  }

  resetTable(): void {
    this.utilsService.saveUserData(this.filterName, this.userChoicesFiltersDefaultUsers);
    this.userSearchCriteria = new UserSearchCriteria(this.userChoicesFiltersDefaultUsers);
    this.filteredUsers();
  }

  filter(user: User): boolean {
    return this.hasBillingAccount(user)
      && this.hasNameOrEmail(user)
      && this.hasRoles(user)
      && !this.isDeleted(user);
  }

  private hasRoles(user: User): boolean {
    if (!this.userSearchCriteria.roles || this.userSearchCriteria.roles.length === 0) {
      return true;
    }
    for (const group of user.roleGroups) {
      if (this.userSearchCriteria.roles.find(role => role === group.name)) {
        return true;
      }
    }
    return false;
  }

  private hasBillingAccount(user: User): boolean {
    if (!this.userSearchCriteria.billingAccount || this.userSearchCriteria.billingAccount.length === 0) {
      return true;
    }
    return !!user.billingAccounts.find(ba => this.userSearchCriteria.billingAccount.includes(ba.name));
  }

  private hasNameOrEmail(user): boolean {
    if (!this.userSearchCriteria.nameOrEmail || this.userSearchCriteria.nameOrEmail === '') {
      return true;
    }

    return user.name.toLowerCase().includes(this.userSearchCriteria.nameOrEmail.toLowerCase())
      || user.email.toLowerCase().includes(this.userSearchCriteria.nameOrEmail.toLowerCase());
  }

  private isDeleted(user: User): boolean {
    if (!user) {
      return true;
    }

    return !!this.deletedUserIds.find(deletedId => user.id === deletedId);
  }

  getFirstUserCompanyName(): string {
    if (!this.currentCompany) {
      return '';
    }
    return this.currentCompany.name;
  }

  getTotalUserRecords(): number {
    return this.filteredListUsers.length;
  }

  customSort(event: SortEvent): void {
    this.tableService.customSort(event);
  }

  filteredUsers() {
    this.filteredListUsers = [];
    this.utilsService.saveUserData(this.filterName,
      {
        nameOrEmail: this.userSearchCriteria.nameOrEmail,
        billingAccount: this.userSearchCriteria.billingAccount,
        roles: this.userSearchCriteria.roles
      });
    this.filteredListUsers = this.users.filter(user => this.filter(user));
  }

  getUserCurrent(): User {
    return this.authenticationService.getUserCurrent();
  }

  filteredUsersByRole(): User[] {
    return this.users.filter(user => this.filterByRole(user));
  }

  filterByRole(user: User): boolean {
    return this.hasRoles(user)
      && !this.isDeleted(user);
  }

  quickExportCSV() {
    this.usersToExport = this.filteredUsersByRole();
    let csv = '\ufeff';
    for (let i = 0; i < this.quickExportCols.length; i++) {
      const col = this.quickExportCols[i];
      csv += '"' + col.header + '"';
      if (i < (this.quickExportCols.length - 1)) {
        csv += ',';
      }
    }
    this.usersToExport.forEach((record) => {
      csv += '\n';
      for (let j = 0; j < this.quickExportCols.length; j++) {
        const col = this.quickExportCols[j];
        let cellData = null;
        if (col.field === 'lastLogin' && record[col.field] !== '') {
          cellData = this.datePipe.transform(new Date(record[col.field]), 'MMM d, y H:mm');
        } else if (isNaN(record[col.field])) {
          cellData = record[col.field];
        }
        if (cellData != null) {
          cellData = String(cellData).replace(/"/g, '""');
        } else {
          cellData = '';
        }
        csv += '"' + cellData + '"';
        if (j < (this.quickExportCols.length - 1)) {
          csv += ',';
        }
      }
    });
    const blob = new Blob([csv], {
      type: 'text/csv;charset=utf-8;'
    });
    const link = document.createElement('a');
    link.style.display = 'none';
    document.body.appendChild(link);
    if (link.download !== undefined) {
      link.setAttribute('href', URL.createObjectURL(blob));
      link.setAttribute('download', this.currentCompany.name + '_users.csv');
      link.click();
    } else {
      csv = 'data:text/csv;charset=utf-8,' + csv;
      window.open(encodeURI(csv));
    }
    document.body.removeChild(link);
  }

  resetApiKey(user: User): void {
    if (confirm('This action will reset user\'s api key. Proceed?')) {
      this.customUserService.resetApiKey(user.uniqid).subscribe({
          next: () => {
            location.assign('/#/' + this.getUserCurrent().company.uniqid + '/' + this.currentCompany.uniqid + '/' + user.uniqid + '/edit');
          },
          error: () => {
            this.error = true;
          }
        }
      );
    }
  }

  resetPassword(user): void {
    if (confirm(`Please confirm reset.`)) {
      this.customUserService.resetPassword(user.uniqid).subscribe({
          next: () => {
            this.success = true;
            this.successMessage = 'Request to reset password successful. A confirmation email has been sent to the following email address: ' + user.email;
            window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
          },
          error: () => {
            this.error = true;
            window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
          }
        }
      );
    }
  }

  resendInvitation(user): void {
    if (confirm('This action will resend an invitation to the user. Do you want to Proceed?')) {
      this.customUserService.resendInvitation(user.uniqid).subscribe({
          next: () => {
            this.success = true;
            this.successMessage = 'Request to resend invitation successful.';
          },
          error: () => {
            this.error = true;
          }
        }
      );
    }
  }

  beforeDeleteUser(user: User) {
    this.manageInvoiceRecipientsService.checkLastUserInInvoiceRecipients(user.uniqid)
      .subscribe({
          next: response => {
            if (response['result'] != null) {
              this.dialogService.open(MessageDialogComponent, {
                header: 'Alert',
                width: '60%',
                data: `This user is the only recipient of ${response['result']} invoices.
                   It cannot be deleted nor deactivated. Please modify the list of recipients first
                   <a href="/#/${this.currentCompany.uniqid}/manage-inv-recipient">here</a>.`
              });
            } else {
              this.deleteUser(user);
            }
          },
          error: error => {
            console.error('Error:', error);
          }
        }
      );
  }

  async deleteUser(user: User): Promise<void> {
    let dialogMessage = `Are you sure you want to delete "${user.name}" ?`;
    const threeMonthsAgo = new Date();
    threeMonthsAgo.setMonth(threeMonthsAgo.getMonth() - 3);
    if (user.lastApiCalled && new Date(user.lastApiCalled) >= threeMonthsAgo) {
      dialogMessage = `This user's API key has been used to call Portal API recently on "${user.lastApiCalledStringFormat}". Before deleting this user, please make sure that their API key is not used in any of your automated processes.`;
    }
    const confirmationResult = await this.showConfirmationDialog(dialogMessage);
    if (confirmationResult) {
      try {
        await firstValueFrom(this.swaggerGeneratedUserService.deleteUserItem(user.id + ''));
        this.users = this.users.filter(u => u !== user);
        this.filteredUsers();
        this.success = true;
        this.successMessage = 'The user has been deleted.';
        this.deleteLastSuperUserError = false;
        window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
      } catch (error) {
        if (error.status === 406) {
          this.deleteLastSuperUserError = true;
        } else {
          this.deleteLastSuperUserError = false;
          this.error = true;
        }
        window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
      }
    }
  }

  private async showConfirmationDialog(message: string): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      this.confirmationService.confirm({
        message: message,
        header: 'Delete Confirmation',
        key: 'deleteUserDialog',
        accept: () => resolve(true),
        reject: () => resolve(false),
      });
    });
  }

  confirmDomain(user: User): void {
    this.loading = true;
    this.utilsService.lockUi();
    this.customUserService.confirmDomain(user.id).subscribe({
      next: () => {
        this.success = true;
        this.successMessage = 'Domain name has been confirmed.';
        user.hasDifferentDomain = false;
        this.loading = false;
        this.fetchUserList();
        this.utilsService.unlockUi();
        this.oneUserWithDifferentDomainName = !!this.users.find(u => u.hasDifferentDomain);
      },
      error: () => {
        this.error = true;
      }
    });
  }

  impersonateUser(email: string) {
    this.authenticationService.impersonateUserUsingWs$(email).subscribe({
      next: () => {
        if ('admin' === this.getUserCurrent().company.uniqid) {
          location.assign('/#/mckay/' + this.getUserCurrent().company.uniqid);
        } else {
          location.assign('/#/client/' + this.getUserCurrent().company.uniqid);
        }
      },
      error: () => {
      }
    });
  }

  isMckayUser(user) {
    return user.roles.includes('ROLE_MCKAY');
  }

  checkEmailNotifications(user: User) {
    this.swaggerGeneratedUserService.putUserItem(user.id + '', {'commercialOptIn': user.commercialOptIn}).subscribe(
      () => {
        if (user.id === this.getUserCurrent().id) {
          this.getUserCurrent().commercialOptIn = user.commercialOptIn;
        }
      }
    );
  }

  canEditUsers() {
    if (this.currentUser) {
      return this.currentUser.permissions.canEditUsers;
    }
    return false;
  }

  getFilename() {
    if (this.currentCompany) {
      return this.currentCompany.name + '_users';
    }
    return '';
  }

  invalidateUser(user: User) {
    this.manageInvoiceRecipientsService.checkLastUserInInvoiceRecipients(user.uniqid)
      .subscribe(
        response => {
          if (response['result'] != null) {
            this.dialogService.open(MessageDialogComponent, {
              header: 'Alert',
              width: '60%',
              data: `This user is the only recipient of ${response['result']} invoices.
                     It cannot be deleted nor deactivated. Please modify the list of recipients first
                     <a href="/#/${this.currentCompany.uniqid}/manage-inv-recipient">here</a>.`
            });
          } else {
            if (confirm(`This user will not be sent any announcement until it logs in again. Please confirm.`)) {
              this.customUserService.invalidateUser(user.uniqid).subscribe(
                () => {
                  this.successInvalidateUser = true;
                  this.errorInvalidateUser = false;
                  window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
                  user.isActive = false;
                }, (error: HttpErrorResponse) => {
                  this.validateUserErrorMessage = error.status === 401
                    ? 'This user is the last active user for at least one assigned role and cannot be invalidated.'
                    : 'There was an error while invalidating the user.';
                  this.successInvalidateUser = false;
                  this.errorInvalidateUser = true;
                  window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
                }
              );
            }
          }
        },
        error => {
          console.error('Error:', error);
        }
      );
  }

  isSuperUser(user: User) {
    return this.userLoggedRolesServiceService.userHasOneOfThoseRoles(user, ['ROLE_MCKAY_SUPER', 'ROLE_CLIENT_SUPER']);
  }

  validateUser(user: any) {
    this.customUserService.validateUser(user.uniqid).subscribe(
      () => {
        this.successInvalidateUser = true;
        this.errorInvalidateUser = false;
        window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
        user.isActive = true;
      }, () => {
        this.validateUserErrorMessage = 'There was an error while validating the user.';
        this.successInvalidateUser = false;
        this.errorInvalidateUser = true;
        window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
      }
    );
  }

  canEditUser(user: any) {
    if (!this.authenticationService.userCurrent.permissions.canEditUsers) {
      return false;
    }
    return this.verifyThatAdminCantUpdateSuperUser(user);
  }

  canResetUserApiKey(user: any) {
    return this.verifyThatAdminCantUpdateSuperUser(user);
  }

  canDeleteOrResetPassword(user: any, deleteAction = false) {
    if (deleteAction && this.userLoggedRolesServiceService.userHasOneOfThoseRoles(user, ['ROLE_MCKAY_SUPER', 'ROLE_CLIENT_SUPER'])) {
      return false;
    }
    if (!this.userLoggedRolesServiceService.userHasOneOfThoseRoles(this.currentUser, ['ROLE_MCKAY_SUPER', 'ROLE_MCKAY_ADMIN', 'ROLE_CLIENT_SUPER', 'ROLE_CLIENT_ADMIN'])) {
      return false;
    }
    return this.verifyThatAdminCantUpdateSuperUser(user);
  }

  private verifyThatAdminCantUpdateSuperUser(user: any) {
    // a non super client can not edit a super client
    if (this.userLoggedRolesServiceService.userHasRole(user, 'ROLE_CLIENT_SUPER')
      && !this.userLoggedRolesServiceService.userHasOneOfThoseRoles(this.currentUser, ['ROLE_MCKAY', 'ROLE_CLIENT_SUPER'])) {
      return false;
    }
    // a non super mckay user can not edit a super mckay user
    return !(this.userLoggedRolesServiceService.userHasRole(user, 'ROLE_MCKAY_SUPER')
      && !this.userLoggedRolesServiceService.userHasRole(this.currentUser, 'ROLE_MCKAY_SUPER'));
  }

  displayItem(event: MouseEvent, overlayPanel: OverlayPanel) {
    overlayPanel.toggle(event);
  }

  parseToStringDate(parsedDate: any) {
    return this.datePipe.transform(parsedDate, 'MMM d, y H:mm');
  }

  reset2Fa(user: any) {
    if (confirm('This action will force the user to reconfigure their Google Authenticator. Proceed?')) {
      this.customUserService.reset2Fa(user.uniqid).subscribe(
        () => {
          user.hasSetupMfa = false;
          this.success = true;
          this.successMessage = 'User 2FA has been reset.';
        },
        () => {
          this.error = true;
        }
      );
    }
  }

  downloadAuthorization(user: any) {
    this.customUserService.downloadUserAuthorization(user.id).subscribe(
      (response: any) => {
        const base64Data = response.file_content;
        const mimeType = response.mime_type;
        const byteCharacters = atob(base64Data);
        const byteArrays = [];
        for (let offset = 0; offset < byteCharacters.length; offset += 512) {
          const slice = byteCharacters.slice(offset, offset + 512);
          const byteNumbers = new Array(slice.length);
          for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);
          byteArrays.push(byteArray);
        }
        const blob = new Blob(byteArrays, {type: mimeType});
        saveAs(blob, response.file_name);
      }, (error) => {
        this.authorizationErrorMessage = error.error.message;
        this.authorizationError = true;
      }
    );
  }

  isNotLoggedSinceSixMonthsAgo(user: User): boolean {
    const currentDate = new Date();
    const sixMonthsAgo = new Date();
    sixMonthsAgo.setMonth(currentDate.getMonth() - 6);
    return new Date(user.lastLogin) < sixMonthsAgo;
  }

  hasNotOnlyFinanceRole(user): boolean {
    return user.roles.includes('ROLE_CLIENT_FINANCE') && user.roles.length > 1;
  }
}
